import React, { useEffect, useState } from "react";
import "./dishpatch.css";

import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";

import { baseURL } from "../../constants/url";

import {
  useParams,
  useNavigate,
} from "react-router-dom";

const Dishpatch = () => {
  const [currentStep, setCurrentStep] =
    useState(1);

  const [order, setOrder] =
    useState(null);

  const { orderId } =
    useParams();

  const navigate =
    useNavigate();

  const token =
    localStorage.getItem(
      "authToken"
    );

  // =====================================================
  // TRACK ORDER STEPS
  // Backend manual status ke according
  // =====================================================

  const labels = [
    "Order Placed",
    "Packed",
    "Shipped",
    "Delivered",
  ];

  const steps = labels.length;

  // =====================================================
  // Backend Status -> Frontend Step
  // =====================================================

  const statusToStepMap = {
    // Order successfully placed / payment complete
    PAID: 1,
    ORDER_PLACED: 1,
    PLACED: 1,
    NOT_SHIPPED: 1,

    // Packed
    PACKED: 2,

    // Shipped
    SHIPPED: 3,

    // Delivered
    DELIVERED: 4,
  };

  // =====================================================
  // Login check + fetch order
  // =====================================================

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    fetchOrderHistory();
  }, [orderId]);

  // =====================================================
  // Normalize Backend Status
  // =====================================================

  const normalizeStatus = (
    status
  ) => {
    if (!status) return "";

    return String(status)
      .toUpperCase()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/-/g, "_");
  };

  // =====================================================
  // FETCH ORDER HISTORY
  // =====================================================

  const fetchOrderHistory =
    async () => {
      try {
        const res =
          await fetch(
            `${baseURL}common/orders_history/`,
            {
              headers: {
                Authorization:
                  `Bearer ${token}`,
              },
            }
          );

        if (!res.ok) {
          throw new Error(
            "Failed to fetch order history"
          );
        }

        const response =
          await res.json();

        console.log(
          "Order History Response:",
          response
        );

        // Support normal array as well as paginated response
        const orders =
          response?.results ||
          response ||
          [];

        if (
          !Array.isArray(orders)
        ) {
          console.error(
            "Invalid order history response:",
            response
          );

          return;
        }

        const selectedOrder =
          orders.find(
            (o) =>
              String(o.id) ===
              String(orderId)
          );

        if (!selectedOrder) {
          console.error(
            "Order not found:",
            orderId
          );

          return;
        }

        setOrder(
          selectedOrder
        );

        console.log(
          "Selected Order:",
          selectedOrder
        );

        // =================================================
        // Get backend status
        // =================================================

        /*
          Backend screenshot me current status PAID hai
          aur manually Packed / Shipped / Delivered hoga.

          Pehle delivery_status check karenge.

          Agar backend status field me value bhej raha hai,
          to usko fallback ke roop me use karenge.
        */

        const backendStatus =
          selectedOrder?.delivery_status ||
          selectedOrder?.status ||
          selectedOrder?.order_status;

        const normalizedStatus =
          normalizeStatus(
            backendStatus
          );

        console.log(
          "Backend Status:",
          backendStatus
        );

        console.log(
          "Normalized Status:",
          normalizedStatus
        );

        const step =
          statusToStepMap[
            normalizedStatus
          ] || 1;

        console.log(
          "Current Tracker Step:",
          step
        );

        setCurrentStep(
          step
        );
      } catch (error) {
        console.error(
          "Order history error:",
          error
        );
      }
    };

  // =====================================================
  // UI
  // =====================================================

  return (
    <>
      <Header />

      <div className="container">

        <div className="row">

          {/* ================================================= */}
          {/* LEFT - TRACK ORDER */}
          {/* ================================================= */}

          <div className="col-md-6 pt_30">

            <div className="card_common">

              <div className="heading_common mb_30">

                <h3>
                  Track Order
                </h3>

              </div>

              <div className="tracker-wrapper">

                {Array.from(
                  {
                    length:
                      steps,
                  },

                  (_, i) => {
                    const stepNumber =
                      i + 1;

                    const isCompleted =
                      stepNumber <=
                      currentStep;

                    const isLineCompleted =
                      stepNumber <
                      currentStep;

                    return (

                      <div
                        className="step-group"
                        key={
                          labels[
                            i
                          ]
                        }
                      >

                        {/* Circle */}

                        <div
                          className={`circle ${
                            isCompleted
                              ? "active"
                              : ""
                          }`}
                        ></div>

                        {/* Label */}

                        <div
                          className={`step-label ${
                            isCompleted
                              ? "active-label"
                              : ""
                          }`}
                        >
                          {
                            labels[
                              i
                            ]
                          }
                        </div>

                        {/* Connecting Line */}

                        {i <
                          steps -
                            1 && (

                          <div
                            className={`line ${
                              isLineCompleted
                                ? "active"
                                : ""
                            }`}
                          ></div>

                        )}

                      </div>
                    );
                  }
                )}

              </div>

            </div>

          </div>

          {/* ================================================= */}
          {/* RIGHT - ORDER DETAILS */}
          {/* Same as your existing code */}
          {/* ================================================= */}

          <div className="col-md-6 pt_30">

            <div className="card_common">

              <div className="heading_common mb_30">

                <h3>
                  Order Details
                </h3>

              </div>

              {order?.items
                ?.length > 0 ? (

                order.items.map(
                  (
                    item,
                    index
                  ) => (

                    <div
                      key={
                        index
                      }
                      className="item_box d_flex mb_15 pb_10 border_bottom_gray gap_15"
                    >

                      <div className="item_box_in">

                        <img
                          src={
                            item.product_image
                          }
                          alt={
                            item.product_name ||
                            "Product"
                          }
                          className="border_radius"
                        />

                      </div>

                      <div>

                        <h6 className="font_12">
                          {
                            item.product_name
                          }
                        </h6>

                        <p className="mb-1">
                          Qty:{" "}
                          {
                            item.quantity
                          }
                        </p>

                        <p className="mb-0">
                          Price: ₹
                          {
                            item.price
                          }
                        </p>

                      </div>

                    </div>
                  )
                )

              ) : (

                <p>
                  No items found.
                </p>

              )}

              <div className="text_right">

                <h5 className="font_13 color_green">

                  Total Price: ₹
                  {
                    order?.amount
                  }

                </h5>

              </div>

            </div>

            {/* ================================================= */}
            {/* DELIVERY ADDRESS */}
            {/* ================================================= */}

            <div className="mt_20">

              <div className="card_common">

                <div className="heading_common">

                  <h3>
                    Delivery Address
                  </h3>

                </div>

                <div className="address_box">

                  <div className="address_card">

                    {order
                      ?.deliveryAddress
                      ?.split(
                        "\n"
                      )
                      .map(
                        (
                          line,
                          index
                        ) => (

                          <p
                            key={
                              index
                            }
                            className="mb-1"
                          >
                            {
                              line
                            }
                          </p>

                        )
                      )}

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      <Subscribe />

      <Footer />
    </>
  );
};

export default Dishpatch;